import { render, staticRenderFns } from "./SignupPersonForm.vue?vue&type=template&id=70bab0df&scoped=true&"
import script from "./SignupPersonForm.vue?vue&type=script&lang=js&"
export * from "./SignupPersonForm.vue?vue&type=script&lang=js&"
import style0 from "./SignupPersonForm.vue?vue&type=style&index=0&id=70bab0df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bab0df",
  null
  
)

export default component.exports